export enum SectionNames {
  Dashboard = 'Dashboard',
  Electronics = 'Electronics',
  DroneParts = 'DroneParts',
  Store = 'Store',
  Suppliers = 'Suppliers',
  Drones = 'Drones',
  Batteries = 'Batteries',
  Settings = 'Settings',
  Orders = 'Orders',
}

export enum RoleNames {
  Admin = 'Admin',
  CEO = 'CEO',
  Manager = 'Manager',
}
export interface IUserPermission {
  allowedSections: SectionNames[];
}

export interface IUser {
  _id: string;
  businessName: string;
  email: string;
  password: string;
  roles: RoleNames[];
}

export interface IUserResponce {
  user: IUser;
  access_token: string;
}

export interface ILoginRequest {
  email: string;
  password: string;
}
